export default "__VITE_ASSET__0baa2338__"